/* NURÉVE — Scroll-Animationen und leichte Parallaxe */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  root.classList.add('nrv-motion');

  function tag(){
    var groups = [
      ['.nrvs-hero-copy > *', 90],
      ['.nrvs-trust .nrvs-trust-item', 80],
      ['.nrvs-cols .nrvs-cols-img, .nrvs-cols .nrvs-cols-text > *', 70],
      ['.nrvs-grid-sec .nrvs-head > *, .nrvs-grid-sec .nrvs-card', 70],
      ['.nrvs-editorial .nrvs-ed-img, .nrvs-editorial .nrvs-ed-copy > *', 70],
      ['.nrvs-cats .nrvs-head > *, .nrvs-cats .nrvs-cat', 70],
      ['.nrvs-quote .nrvs-quote-inner > *', 90],
      ['.nrvs-colhead .nrvs-wrap > *', 80],
      ['.nrvs-prodtrust .nrvs-pt-item', 70],
      ['.nrvs-prodstory .nrvs-ps-img, .nrvs-prodstory .nrvs-ps-copy > *', 70],
      ['.nrvs-proddetails .nrvs-pd-intro > *, .nrvs-proddetails .nrvs-pd-item', 55],
      ['.nrvs-prodrev .nrvs-head > *, .nrvs-prodrev .nrvs-rev', 80],
      ['.nrvs-carthead .nrvs-ch-row > *', 80],
      ['.nrvf-com-head > *', 80],
      ['.nrvf-com-tile', 90],
      ['.nrvf-news-media, .nrvf-news-copy > *', 75],
      ['.nrvf-grid > *, .nrvf-widerruf > *, .nrvf-quote > *', 70]
    ];
    groups.forEach(function(g){
      var nodes = document.querySelectorAll(g[0]);
      var i = 0;
      nodes.forEach(function(el){
        if(el.hasAttribute('data-nrv-reveal')) return;
        el.setAttribute('data-nrv-reveal','');
        el.style.setProperty('--nrv-delay', Math.min(i,6) * g[1] + 'ms');
        i++;
      });
    });

    document.querySelectorAll('h1, h2').forEach(function(el){
      if(el.closest('.nrvh-wrap')) return;
      if(el.hasAttribute('data-nrv-reveal')) return;
      el.setAttribute('data-nrv-reveal','head');
    });
  }

  function observe(){
    var targets = document.querySelectorAll('[data-nrv-reveal]:not(.nrv-in)');
    if(reduce || !('IntersectionObserver' in window)){
      targets.forEach(function(el){el.classList.add('nrv-in');});
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('nrv-in');
          io.unobserve(e.target);
        }
      });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    targets.forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < window.innerHeight * 0.92){ el.classList.add('nrv-in'); }
      else { io.observe(el); }
    });
    setTimeout(function(){
      document.querySelectorAll('[data-nrv-reveal]:not(.nrv-in)').forEach(function(el){
        var r = el.getBoundingClientRect();
        if(r.top < window.innerHeight){ el.classList.add('nrv-in'); }
      });
    }, 1200);
  }

  function parallax(){
    if(reduce) return;
    var layers = document.querySelectorAll('.nrvs-quote .nrvs-quote-media img, .nrvs-colhead .nrvs-colhead-media img');
    if(!layers.length) return;
    var ticking = false;
    function frame(){
      layers.forEach(function(img){
        var sec = img.closest('section');
        if(!sec) return;
        var r = sec.getBoundingClientRect();
        if(r.bottom < 0 || r.top > window.innerHeight) return;
        var progress = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        /* Größerer Grundzoom + kleinerer Versatz: die Bildkante bleibt
           unter allen Umständen außerhalb des sichtbaren Rahmens. */
        var shift = (progress - 0.5) * 30;
        img.style.transform = 'scale(1.2) translate3d(0,' + shift.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){ ticking = true; window.requestAnimationFrame(frame); }
    }, {passive:true});
    frame();
  }

  function boot(){ tag(); observe(); parallax(); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', function(){ tag(); observe(); });
})();
